import {
  UpdateTenantPayload,
  UpdateTenantResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateTenant(
  tenantId: string,
  onSuccess?: (data: UpdateTenantResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants/${tenantId}`;
  const request = new Request(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<UpdateTenantResponse, UpdateTenantPayload>(
    request,
    {
      onSuccessInvalidationKeys: [
        ['admin-tenants'],
        ['admin-tenant-details', tenantId],
      ],
      onSuccess,
      onError,
    }
  );
}

export default useUpdateTenant;
